(function ($) {
  "use strict";

  var alcadon = {
    init: function () {
      this.mainMenuBlock();
      this.mainMenuBlock1();
      this.scrollLink();
      this.submenuOpener();
      this.submenuOpenerSidemenu();
      this.stickyHeader();
      this.languageTrigger();
      this.customTabs();
      this.stickyAndScroll();
      this.calendarSlider();
    },

    mainMenuBlock: function () {
      jQuery("header").on("click", ".navbar-toggle-btn", function (e) {
        e.preventDefault();
        if (!jQuery(this).hasClass("nav-open")) {
          jQuery("#navbar").removeClass("active");
          jQuery("html").removeClass("menu-active");
          jQuery(this).removeClass("nav-close").addClass("nav-open");
        } else {
          jQuery("#navbar").addClass("active");
          jQuery("html").addClass("menu-active");
          jQuery(this).removeClass("nav-open").addClass("nav-close");
        }
      });
    },

    mainMenuBlock1: function () {
      jQuery("header").on(
        "click",
        ".navbar-toggle-btn.nav-close",
        function (e) {
          jQuery("html").removeClass("submenu-active");
          jQuery(".nav-item").removeClass("opened");
          jQuery(".submenu-opener").removeClass("closed");
          jQuery(".dropdown-menu").css("display", "none");
        },
      );
    },

    scrollLink: function () {
      $(document).ready(function () {
        function getOffset() {
          return $(window).width() > 991 ? 151 : 101;
        }

        function scrollToTarget(hash, speed = 800) {
          var target = $(hash);

          if (target.length) {
            $("html, body")
              .stop()
              .animate(
                {
                  scrollTop: target.offset().top - getOffset(),
                },
                speed,
              );
          }
        }

        // Smooth scroll on page load with hash
        if (window.location.hash) {
          setTimeout(function () {
            scrollToTarget(window.location.hash, 800);
          }, 100);
        }

        // Smooth scroll on anchor click
        $(
          '.main-header nav.navbar .collapse .menu-content .menu-wrapper ul.nav > .nav-item .dropdown-menu .mega-menu-container ul li a[href*="/#"], a[href^="#"]',
        ).on("click", function (e) {
          var hash = this.hash;

          if (!hash) return;

          var pathname = location.pathname.replace(/^\//, "");
          var thisPath = this.pathname.replace(/^\//, "");

          // Same page
          if (location.hostname === this.hostname && pathname === thisPath) {
            e.preventDefault();

            scrollToTarget(hash, 800);

            history.replaceState(null, null, hash);
          }
        });
      });
    },

    submenuOpener: function () {
      jQuery("header.main-header .navbar-nav .submenu-opener").on(
        "click",
        function (e) {
          // e.preventDefault();

          const $this = jQuery(this);

          // CLOSE all other open dropdowns
          jQuery("header.main-header .navbar-nav .submenu-opener")
            .not($this)
            .removeClass("closed")
            .parent(".nav-item")
            .removeClass("opened")
            .find(".dropdown-menu")
            .slideUp();

          // TOGGLE current dropdown
          if (!$this.hasClass("closed")) {
            jQuery("html").addClass("submenu-active");

            $this.addClass("closed");
            $this.parent(".nav-item").addClass("opened");
            $this.next(".dropdown-menu").slideDown();
          } else {
            jQuery("html").removeClass("submenu-active");

            $this.removeClass("closed");
            $this.parent(".nav-item").removeClass("opened");
            $this.next(".dropdown-menu").slideUp();
          }
        },
      );
    },

    submenuOpenerSidemenu: function () {
      jQuery(".sticky-nav-block .submenu-opener").on("click", function (e) {
        e.preventDefault();

        var $this = jQuery(this);
        var $currentMenu = $this.next("ul.dropdown-menu");

        // Close all other open menus
        jQuery(".sticky-nav-block .submenu-opener")
          .not($this)
          .removeClass("opened")
          .next("ul.dropdown-menu")
          .slideUp();

        // Toggle current menu
        $this.toggleClass("opened");
        $currentMenu.slideToggle();
      });
    },

    stickyHeader: function () {
      jQuery(function () {
        function toggleStickyHeader() {
          var sticky = jQuery("header"),
            scroll = jQuery(window).scrollTop();

          if (scroll >= 1) {
            sticky.addClass("sticky-header");
          } else {
            sticky.removeClass("sticky-header");
          }
        }

        jQuery(window).on("scroll", toggleStickyHeader);
        toggleStickyHeader(); // Trigger once on page load
      });
    },

    languageTrigger: function () {
      jQuery(".language-selector-trigger").on("click", function () {
        jQuery(".language-selector .sub-menu").slideToggle();
        jQuery(this).toggleClass("rotate");
      });
    },

    customTabs: function () {
      $(document).ready(function () {
        function openTab(target) {
          var $content = $(target);
          if (!$content.length) return;

          var group = $content.data("tab-group");

          // Hide only tab contents from same group
          $('.tab-content[data-tab-group="' + group + '"]').hide();

          // Show selected tab
          $content.fadeIn(200);

          // Update active class in same group
          $(
            '.tabs-wrapper[data-tab-group="' + group + '"] .tabs-nav li',
          ).removeClass("active");

          $(
            '.tabs-wrapper[data-tab-group="' +
              group +
              '"] .tabs-nav li a[href="' +
              target +
              '"]',
          )
            .parent()
            .addClass("active");
        }

        // Initial setup - first tab active in each wrapper
        $(".tabs-wrapper").each(function () {
          var group = $(this).data("tab-group");
          var firstTab = $(this).find(".tabs-nav li:first a").attr("href");

          if (firstTab) {
            $('.tab-content[data-tab-group="' + group + '"]').hide();
            $(firstTab).show();
            $(this).find(".tabs-nav li:first").addClass("active");
          }
        });

        // Click inside tab navigation
        $(".tabs-nav li a").on("click", function (e) {
          e.preventDefault();
          var target = $(this).attr("href");
          openTab(target);
        });

        // External links anywhere on page
        $('a[href^="#"]').on("click", function (e) {
          var target = $(this).attr("href");
          if ($(target).hasClass("tab-content")) {
            e.preventDefault();
            openTab(target);
          }
        });

        // Open tab from URL hash on page load
        if (
          window.location.hash &&
          $(window.location.hash).hasClass("tab-content")
        ) {
          openTab(window.location.hash);
        }
      });
    },

    stickyAndScroll: function () {
      // $(document).ready(function () {
      //   var $nav = $(".sticky-nav-block");

      //   if (!$nav.hasClass("has-scroll-links")) return;

      //   var $links = $nav.find("a");
      //   var $blocks = $(".aside-content .single-block");

      //   var isClickScrolling = false;

      //   function getOffset() {
      //     return $(window).width() < 1199 ? 101 : 151;
      //   }

      //   // ✅ Set FIRST block active
      //   var firstBlock = $blocks.first();
      //   var firstId = firstBlock.attr("id");

      //   if (firstId && firstId.trim() !== "") {
      //     $links.removeClass("active");
      //     $links.filter('[href="#' + firstId + '"]').addClass("active");
      //   } else {
      //     $links.removeClass("active");
      //   }

      //   // ✅ CLICK HANDLER
      //   $links.on("click", function (e) {
      //     var linkHref = $(this).attr("href");

      //     if (!linkHref || linkHref.indexOf("#") === -1) return;

      //     var idElement = linkHref.substring(linkHref.indexOf("#"));
      //     var $target = $(idElement);

      //     if (!$target.length) return;

      //     e.preventDefault();

      //     var offset = getOffset();
      //     isClickScrolling = true;

      //     var isDropdownItem = $(this).closest(".dropdown-menu").length > 0;

      //     if (isDropdownItem) {
      //       var $parentSection = $target.closest(".single-block");

      //       $("html, body")
      //         .stop()
      //         .animate(
      //           {
      //             scrollTop: $parentSection.offset().top - offset,
      //           },
      //           500,
      //           function () {
      //             var $scrollContainer = $parentSection.find(".h-500");

      //             if ($scrollContainer.length) {
      //               var innerOffset =
      //                 $target.offset().top -
      //                 $scrollContainer.offset().top +
      //                 $scrollContainer.scrollTop();

      //               $scrollContainer.animate(
      //                 {
      //                   scrollTop: innerOffset,
      //                 },
      //                 400,
      //               );
      //             }

      //             setTimeout(function () {
      //               isClickScrolling = false;
      //             }, 50);
      //           },
      //         );
      //     } else {
      //       $("html, body")
      //         .stop()
      //         .animate(
      //           {
      //             scrollTop: $target.offset().top - offset,
      //           },
      //           500,
      //           function () {
      //             setTimeout(function () {
      //               isClickScrolling = false;
      //             }, 50);
      //           },
      //         );
      //     }

      //     $links.removeClass("active");
      //     $(this).addClass("active");
      //   });

      //   // ✅ SCROLL HANDLER
      //   $(window).on("scroll", function () {
      //     if (isClickScrolling) return;

      //     var scroll = $(window).scrollTop();
      //     var offset = getOffset();

      //     var found = false;

      //     $blocks.each(function () {
      //       var id = $(this).attr("id");

      //       if (!id || id.trim() === "") return;

      //       var top = $(this).offset().top - offset;
      //       var bottom = top + $(this).outerHeight();

      //       if (scroll >= top && scroll < bottom) {
      //         $links.removeClass("active");
      //         $links.filter('[href="#' + id + '"]').addClass("active");
      //         found = true;
      //         return false;
      //       }
      //     });

      //     var firstValidBlock = $blocks
      //       .filter(function () {
      //         var id = $(this).attr("id");
      //         return id && id.trim() !== "";
      //       })
      //       .first();

      //     if (!found && firstValidBlock.length) {
      //       var firstTop = firstValidBlock.offset().top - offset;

      //       if (scroll < firstTop) {
      //         var firstValidId = firstValidBlock.attr("id");
      //         $links.removeClass("active");
      //         $links
      //           .filter('[href="#' + firstValidId + '"]')
      //           .addClass("active");
      //       }
      //     }
      //   });
      // });

      $(document).ready(function () {
        var $nav = $(".sticky-nav-block");

        if (!$nav.hasClass("has-scroll-links")) return;

        var $links = $nav.find("a");
        var $blocks = $(".aside-content .single-block");

        var isClickScrolling = false;

        function getOffset() {
          return $(window).width() < 1199 ? 101 : 151;
        }

        // ✅ Set FIRST block active
        var firstBlock = $blocks.first();
        var firstId = firstBlock.attr("id");

        if (firstId && firstId.trim() !== "") {
          $links.removeClass("active");
          $links.filter('[href="#' + firstId + '"]').addClass("active");
        } else {
          $links.removeClass("active");
        }

        // ✅ CLICK HANDLER
        $links.on("click", function (e) {
          var linkHref = $(this).attr("href");

          if (!linkHref || linkHref.indexOf("#") === -1) return;

          var idElement = linkHref.substring(linkHref.indexOf("#"));
          var $target = $(idElement);

          if (!$target.length) return;

          e.preventDefault();

          var offset = getOffset();
          isClickScrolling = true;

          var isDropdownItem = $(this).closest(".dropdown-menu").length > 0;

          if (isDropdownItem) {
            var $parentSection = $target.closest(".single-block");

            $("html, body")
              .stop()
              .animate(
                {
                  scrollTop: $parentSection.offset().top - offset,
                },
                500,
                function () {
                  var $scrollContainer = $parentSection.find(".h-500");

                  // ✅ ONLY scroll if target has .financial-report class
                  if (
                    $scrollContainer.length &&
                    $target.hasClass("financial-report")
                  ) {
                    var innerOffset =
                      $target.offset().top -
                      $scrollContainer.offset().top +
                      $scrollContainer.scrollTop();

                    $scrollContainer.animate(
                      {
                        scrollTop: innerOffset,
                      },
                      400,
                    );
                  }

                  setTimeout(function () {
                    isClickScrolling = false;
                  }, 50);
                },
              );
          } else {
            $("html, body")
              .stop()
              .animate(
                {
                  scrollTop: $target.offset().top - offset,
                },
                500,
                function () {
                  setTimeout(function () {
                    isClickScrolling = false;
                  }, 50);
                },
              );
          }

          $links.removeClass("active");
          $(this).addClass("active");
        });

        // ✅ SCROLL HANDLER
        $(window).on("scroll", function () {
          if (isClickScrolling) return;

          var scroll = $(window).scrollTop();
          var offset = getOffset();

          var found = false;

          $blocks.each(function () {
            var id = $(this).attr("id");

            if (!id || id.trim() === "") return;

            var top = $(this).offset().top - offset;
            var bottom = top + $(this).outerHeight();

            if (scroll >= top && scroll < bottom) {
              $links.removeClass("active");
              $links.filter('[href="#' + id + '"]').addClass("active");
              found = true;
              return false;
            }
          });

          var firstValidBlock = $blocks
            .filter(function () {
              var id = $(this).attr("id");
              return id && id.trim() !== "";
            })
            .first();

          if (!found && firstValidBlock.length) {
            var firstTop = firstValidBlock.offset().top - offset;

            if (scroll < firstTop) {
              var firstValidId = firstValidBlock.attr("id");
              $links.removeClass("active");
              $links
                .filter('[href="#' + firstValidId + '"]')
                .addClass("active");
            }
          }
        });
      });
    },

    calendarSlider: function () {
      $(document).ready(function () {
        var $slider = $(".calendar-slider");
        var $prevBtn = $(".prev-btn");
        var $nextBtn = $(".next-btn");

        // Sort items by year (descending)
        var $items = $slider.children(".custom-box.calendar").get();

        $items.sort(function (a, b) {
          var yearA = parseInt($(a).find(".heading-block").text().trim());
          var yearB = parseInt($(b).find(".heading-block").text().trim());
          return yearB - yearA;
        });

        $.each($items, function (index, item) {
          $slider.append(item);
        });

        // Update disabled state
        function updateButtons(slick) {
          $prevBtn.toggleClass("disabled", slick.currentSlide === 0);
          $nextBtn.toggleClass(
            "disabled",
            slick.currentSlide === slick.slideCount - 1,
          );
        }

        // Before slide change → hide buttons
        $slider.on("beforeChange", function () {
          $prevBtn.css("opacity", "0");
          $nextBtn.css("opacity", "0");
        });

        // After slide change → show buttons + update state
        $slider.on("init afterChange", function (event, slick) {
          updateButtons(slick);

          $prevBtn.css("opacity", "1");
          $nextBtn.css("opacity", "1");
        });

        // Initialize slick
        $slider.slick({
          slidesToShow: 1,
          slidesToScroll: 1,
          infinite: false,
        });

        // Button controls
        $prevBtn.on("click", function () {
          if ($(this).hasClass("disabled")) return;
          $slider.slick("slickPrev");
        });

        $nextBtn.on("click", function () {
          if ($(this).hasClass("disabled")) return;
          $slider.slick("slickNext");
        });
      });
    },
  };

  alcadon.init();
})(jQuery);
